import { IItem } from '@checkout/items';
import { RootState } from '@checkout/state';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Button, IconButton, ProductImage, ProductName, SvgIcon } from '..';
import messages from '../../../i18n/base-en';
import * as Styles from './ProductDetails.scss';

interface IOwnProps {
  increase: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
  decrease: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
  removeProduct: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
  quantity: number;
  item: IItem;
  close: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
}

interface IConnectedProps {
  grandTotalPrice: string;
}

type Props = IOwnProps & IConnectedProps & InjectedIntlProps;

const ProductDetails: React.SFC<Props> = ({ increase, decrease, removeProduct, quantity, item, close, grandTotalPrice, intl }) => {
  const { product, priceEach, anyDiscount, priceEachBeforeDiscount } = item;
  const uri = product && product.categoryUri ? `/${ product.categoryUri }/${ product.uri }` : `/${ product.uri }`;
  const { formatMessage } = intl;

  return (
    <div className={Styles.wrapper}>
      <div className={Styles.content}>
        <div className={Styles.button}>
          <Button
            variant="clear"
            iconOutside={<SvgIcon icon="arrowLeft" />}
            size="small"
            type="button"
            label={formatMessage(messages.open_order_label, { grandTotalPrice })}
            onClick={close}
          />
        </div>
        {product && product.media && product.media.standard && (
          <div className={Styles.image}>
            <ProductImage onClick={{ uri }} src={product.media.standard[0]} alt={product.name} />
          </div>
        )}
        <div className={Styles.header}>
          <ProductName name={item.product.name} onClick={{ uri }} size="big" />
          <div className={Styles.price}>
            {anyDiscount && <span className={Styles.beforeDiscount}>{priceEachBeforeDiscount}</span>}
            <span className={Styles.priceValue}>{priceEach}</span>
          </div>
        </div>
        {product.descriptionHtml && (
          <div className={Styles.description} dangerouslySetInnerHTML={ { __html: product.descriptionHtml } } />
        )}
        <div className={Styles.buttonsWrapper}>
          <div className={Styles.buttons}>
            <div className={Styles.quantityButtons}>
              <IconButton onClick={decrease} icon="minus" size="big" />
              <span className={Styles.quantity}>{quantity}</span>
              <IconButton onClick={increase} icon="plus" size="big" />
            </div>
            <div className={Styles.removeButton}>
              <Button type="button" variant="outline" size="medium" label="Remove" onClick={removeProduct} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default compose<React.ComponentClass<IOwnProps>>(
  injectIntl,
  connect<IConnectedProps, {}>(
    (state: RootState) => ({
      grandTotalPrice: state.checkout.selection && state.checkout.selection.totals && state.checkout.selection.totals.grandTotalPrice,
    }),
    {},
  )
)(ProductDetails);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/ProductDetails/ProductDetails.tsx